import { Send } from 'lucide-react'
import { useAuth } from '@/hooks/useAuth'
import { TELEGRAM_BOT_URL } from '@/lib/telegram'
import { TelegramLoginWidget } from '@/components/TelegramLoginWidget'

/** P0.54 (29/08/2026, Sección 13/35 del encargo): pantalla de entrada para navegador externo
 * (fuera de Telegram WebApp) -- reemplaza el dead-end de P0.39 ("Abre desde Telegram") ahora
 * que SÍ hay un camino real de login sin volver a Telegram. Nunca un formulario usuario/
 * contraseña, nunca una pantalla técnica ("Missing initData") -- solo el widget oficial de
 * Telegram + una explicación breve. */
export function LoginScreen() {
  const { loginWithTelegram, error } = useAuth()

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-6 text-center gap-4 animate-fade-in-up motion-reduce:animate-none">
      <div className="relative">
        <div className="absolute inset-0 rounded-full bg-brand/20 blur-[2px]" />
        <img
          src="/logo-96.png"
          alt="John Anthony"
          className="relative h-16 w-16 rounded-full border border-brand/50 object-cover"
        />
      </div>

      <div className="space-y-1.5">
        <h1 className="text-lg font-black text-text">Bienvenido a John Anthony</h1>
        <p className="text-sm text-text-muted max-w-xs mx-auto">
          Entra con Telegram para acceder a tu cuenta.
        </p>
      </div>

      <div className="w-full max-w-xs">
        <TelegramLoginWidget onAuth={loginWithTelegram} />
      </div>

      {error && <p className="text-xs text-danger max-w-xs">{error}</p>}

      <p className="text-[11px] text-text-dim max-w-xs leading-relaxed">
        Usamos Telegram para identificar tu cuenta de forma segura. No necesitas crear otra
        contraseña.
      </p>

      <a
        href={TELEGRAM_BOT_URL}
        className="mt-1 inline-flex items-center gap-1.5 text-xs text-text-dim hover:text-brand transition"
      >
        <Send className="h-3.5 w-3.5" />
        Abrir en Telegram
      </a>
    </div>
  )
}
